import React from 'react';
import { func, bool, number } from 'prop-types';
import Radium from 'radium';
import { UTButton, WithLoading, UTLoading } from '@widergy/energy-ui';

import SecondaryTopbar from 'app/components/SecondaryTopbar';
import { message } from 'utils/stringUtils';
import { accountPropTypes } from 'redux/accountHandlers';
import { formPropType } from 'redux/userFormHandlers';
import { appConfig } from 'config/customization';

import AccountList from './components/AccountList';
import CreateAccount from './components/CreateAccount';
import RelatedSuppliesModal from './components/RelatedSuppliesModal';
import styles from './styles';

function AccountScene({
  onAddAccountPress,
  modalIsOpen,
  closeModal,
  accounts,
  onReturn,
  onDeleteAccount,
  deleteModalIsOpen,
  onDeleteModalOpen,
  onDeleteModalClose,
  deleteAccountId,
  automaticDebitForm,
  digitalBillForm,
  relatedSuppliesModalIsOpen,
  onRelatedSuppliesModalClose,
  onAssociateModalOpen,
  deleteAccountLoading,
  onRowsRendered,
  onClick,
  appending
}) {
  return (
    <div style={styles.container}>
      <SecondaryTopbar titleText={message('Accounts:accounts')}>
        {appConfig.signUpFlow.AddAccount && (
          <UTButton onPress={onAddAccountPress} type="submit" style={styles.addAccount}>
            {message('Accounts:addAccount')}
          </UTButton>
        )}
      </SecondaryTopbar>
      <CreateAccount modalIsOpen={modalIsOpen} closeModal={closeModal} />
      <RelatedSuppliesModal
        relatedSuppliesModalIsOpen={relatedSuppliesModalIsOpen}
        onRelatedSuppliesModalClose={onRelatedSuppliesModalClose}
      />
      <AccountList
        automaticDebitForm={automaticDebitForm}
        digitalBillForm={digitalBillForm}
        accounts={accounts}
        onReturn={onReturn}
        onRowsRendered={onRowsRendered}
        onDeleteAccount={onDeleteAccount}
        deleteModalIsOpen={deleteModalIsOpen}
        onDeleteModalOpen={onDeleteModalOpen}
        onDeleteModalClose={onDeleteModalClose}
        deleteAccountId={deleteAccountId}
        deleteAccountLoading={deleteAccountLoading}
        onAssociateModalOpen={onAssociateModalOpen}
        onClick={onClick}
      />
      {appending && (
        <div style={styles.spinnerContainer}>
          <UTLoading loading={appending} size={45} text=" " />
        </div>
      )}
    </div>
  );
}

AccountScene.propTypes = {
  onAddAccountPress: func,
  modalIsOpen: bool.isRequired,
  closeModal: func.isRequired,
  accounts: accountPropTypes,
  onReturn: func.isRequired,
  onDeleteAccount: func.isRequired,
  deleteModalIsOpen: bool.isRequired,
  onDeleteModalOpen: func.isRequired,
  onDeleteModalClose: func.isRequired,
  deleteAccountId: number,
  automaticDebitForm: formPropType,
  digitalBillForm: formPropType,
  relatedSuppliesModalIsOpen: func,
  onRelatedSuppliesModalClose: func,
  onAssociateModalOpen: func,
  deleteAccountLoading: bool,
  appending: bool,
  onRowsRendered: func,
  onClick: func
};

export default WithLoading(props => props.loading)(Radium(AccountScene));
